"use client";

import { Languages, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePrefs } from "@/components/providers/app-providers";

export function PrefToggles({ className }: { className?: string }) {
  const { locale, theme, toggleLocale, toggleTheme, t } = usePrefs();

  return (
    <div className={className ?? "flex items-center gap-1"}>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        className="h-9 px-2.5"
        onClick={toggleLocale}
        aria-label={t("language")}
        title={locale === "he" ? t("langEn") : t("langHe")}
      >
        <Languages className="h-4 w-4" />
        <span className="text-xs font-semibold uppercase tracking-wide">
          {locale === "he" ? "EN" : "עב"}
        </span>
      </Button>
      <Button
        type="button"
        size="icon"
        variant="ghost"
        onClick={toggleTheme}
        aria-label={t("theme")}
        title={theme === "dark" ? t("themeLight") : t("themeDark")}
      >
        {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>
    </div>
  );
}
